import React, { useContext, useState } from "react"

import { useHistory } from "react-router-dom"
import { gql, useQuery } from "urql"

import { path } from "~Tutor/TutorRoutes"
import { H2, StyledLink, WithLoadingIndicator } from "~tailwindui/Basics"
import { AutocompleteNavigate } from "~tailwindui/Form"
import Table from "~tailwindui/Table/Table"

import LocalTime from "components/LocalTime"
import TutorContext from "components/Tutor/TutorContext"
import ScheduleSessionForStudentButton from "components/Tutor/components/Sessions/ScheduleSessionForStudentButton"

const Students = () => {
  const history = useHistory()
  const { viewer } = useContext(TutorContext)
  const [page, setPage] = useState(1)

  const [result] = useQuery({
    query,
    variables: { page, tutorId: viewer.id },
  })

  return (
    <WithLoadingIndicator result={result}>
      {({ data: { viewer } }) => (
        <>
          <H2>Your Students</H2>
          <div className="flex w-full flex-col gap-4 sm:flex-row">
            <AutocompleteNavigate
              resource="students"
              searchColumn="fullName"
              placeholder="Quick Find a Student"
              navigateTo="studentDetails"
              className="w-64"
            />
          </div>

          <Table
            data={viewer.students}
            changePage={setPage}
            rowCallback={({ id }) => {
              history.push(path("studentDetails", { id }))
            }}
            cols={[
              {
                header: "Student",
                value: student => (
                  <div key={student.id}>
                    <StyledLink
                      to={path("studentDetails", {
                        id: student.id,
                      })}
                    >
                      {student.fullName}{" "}
                    </StyledLink>
                  </div>
                ),
              },
              {
                header: "Study Groups",
                value: student => (
                  <ul>
                    {student.studyGroups.map(group => (
                      <li key={group.id}>
                        <StyledLink
                          to={path("studyGroupDetails", { id: group.id })}
                        >
                          {group.name}
                        </StyledLink>
                      </li>
                    ))}
                  </ul>
                ),
              },
              {
                header: "Next Session",
                value: student => (
                  <>
                    {student.nextSession ? (
                      <StyledLink
                        to={path("sessionDetails", {
                          id: student.nextSession.id,
                        })}
                      >
                        <LocalTime timestamp={student.nextSession.startsAt} />
                      </StyledLink>
                    ) : (
                      <ScheduleSessionForStudentButton student={student} />
                    )}
                  </>
                ),
              },
            ]}
          />
        </>
      )}
    </WithLoadingIndicator>
  )
}

const query = gql`
  query StudentsIndex($page: Int, $tutorId: ID!) {
    viewer {
      id
      students(orderByLastSession: true, page: $page) {
        currentPage
        totalPages
        data {
          id
          fullName
          firstName
          hasPrivateBillingMethod
          studyGroups(tutorId: $tutorId) {
            id
            name
            tutorMaySchedule
            oneOnOne
            organization {
              id
            }
          }
          tutorToStudentPhoneNumber(tutorId: $tutorId)
          parentName
          tutorToParentPhoneNumber(tutorId: $tutorId)
          secondaryParentName
          tutorToSecondaryParentPhoneNumber(tutorId: $tutorId)
          nextSession(tutorId: $tutorId) {
            id
            startsAt
          }
        }
      }
    }
  }
`

export default Students
